import { Injectable, inject } from "@angular/core";
import { AbstractControl, ValidationErrors } from "@angular/forms";
import { AsyncValidator, registerAsyncValidatorDecorator } from "@recursyve/ngx-form-generator";
import { Observable, of, timer } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { ApiService } from "../../../../../../api/api.service";

export function EnhancementCapsuleNameExists() {
    return registerAsyncValidatorDecorator({
        name: "EnhancementCapsuleNameExistsValidator"
    });
}

@Injectable()
export class EnhancementCapsuleNameExistsValidator extends AsyncValidator {
    private readonly apiService = inject(ApiService);

    public readonly name = "EnhancementCapsuleNameExistsValidator";

    public validate(control: AbstractControl): Observable<ValidationErrors | null> {
        if (!control.value || control.value === "") {
            return of(null);
        }

        return timer(200).pipe(
            switchMap(() =>
                this.apiService.enhancementCapsules.nameAlreadyUsed(control.value).pipe(
                    map((isNewEnhancementCapsuleNameValid) => {
                        if (!isNewEnhancementCapsuleNameValid) {
                            control.markAsTouched();
                            return {
                                enhancement_capsule_name_already_used: true
                            };
                        }
                        return null;
                    })
                )
            )
        );
    }
}
